(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_audio-advice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('audio-advice-player')) {
    customElements.define(
      'audio-advice-player',
      class AudioAdvicePlayer extends HTMLElement {
        connectedCallback() {
          this.audio = this.querySelector('.audio-advice__audio');
          this.playButton = this.querySelector('.audio-advice__play');
          this.fill = this.querySelector('.audio-advice__fill');
          this.currentTimeEl = this.querySelector('.audio-advice__time-current');
          this.durationEl = this.querySelector('.audio-advice__time-duration');

          if (!this.audio || !this.playButton) return;

          this.playButton.addEventListener('click', this.togglePlay.bind(this));
          this.audio.addEventListener('loadedmetadata', this.updateDuration.bind(this));
          this.audio.addEventListener('timeupdate', this.updateProgress.bind(this));
          this.audio.addEventListener('play', () => this.setAttribute('data-playing', 'true'));
          this.audio.addEventListener('pause', () => this.setAttribute('data-playing', 'false'));

          this.viewObserver = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting && !this.audio.paused) {
              this.audio.pause();
            }
          });
          this.viewObserver.observe(this);
        }

        disconnectedCallback() {
          if (this.viewObserver) this.viewObserver.disconnect();
        }

        togglePlay() {
          if (this.audio.paused) {
            this.audio.play();
          } else {
            this.audio.pause();
          }
        }

        formatTime(seconds) {
          if (!isFinite(seconds)) return '0:00';
          const mins = Math.floor(seconds / 60);
          const secs = Math.floor(seconds % 60)
            .toString()
            .padStart(2, '0');
          return `${mins}:${secs}`;
        }

        updateDuration() {
          this.durationEl.textContent = this.formatTime(this.audio.duration);
        }

        updateProgress() {
          const percent = (this.audio.currentTime / this.audio.duration) * 100 || 0;
          this.fill.style.width = `${percent}%`;
          this.currentTimeEl.textContent = this.formatTime(this.audio.currentTime);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_footer-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) return;

    if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
      event.preventDefault();
      window.Cookiebot.renew();
      return;
    }

    // Cookiebot assente: con un href che punta a una pagina si lascia navigare,
    // con la sola ancora non c'è nulla da aprire e si evita di sporcare l'URL
    var href = trigger.getAttribute('href') || '';
    if (href.charAt(0) === '#') event.preventDefault();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_menu-drawer-banner-slider"] && !Shopify.designMode) return;
  try {
    class SfBannerSlider extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._slides = Array.from(this.querySelectorAll('.slideshow__slide[id]'));
      if (!this._slides.length) return;

      this._current = 0;
      this._speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;

      this._slides[0].classList.add('is-active');

      if (this._slides.length > 1) {
        this._buildPagination();
        this._startAutoplay();
        this.addEventListener('mouseenter', () => this._stopAutoplay());
        this.addEventListener('mouseleave', () => this._startAutoplay());
        this._bindSwipe();

        // A page restored from the browser's back/forward cache, or
        // activated from a prerendered background load, keeps this
        // element's JS state exactly as it was — including a still-ticking
        // autoplay timer — so _current can drift out of sync with what's
        // actually on screen by the time the user taps again. pageshow
        // fires on every appearance of the page (fresh load and restores
        // alike), so force a clean resync there.
        window.addEventListener('pageshow', () => this._resetToFirstSlide());
      }
    }

    _resetToFirstSlide() {
      this._slides[this._current].classList.remove('is-active');
      if (this._dots) this._dots[this._current].classList.remove('slider__pagination-item--active');
      this._current = 0;
      this._slides[0].classList.add('is-active');
      if (this._dots) this._dots[0].classList.add('slider__pagination-item--active');
      this._startAutoplay();
    }

    _bindSwipe() {
      const container = this.querySelector('.menu-drawer__banner-slideshow');
      if (!container) return;
      let startX = 0;
      let startY = 0;
      let dragging = false;

      // Only changes _current on drag release — never touches click/tap at
      // all, so the <a> links stay 100% native and unaffected either way.
      container.addEventListener('pointerdown', (e) => {
        dragging = true;
        startX = e.clientX;
        startY = e.clientY;
      });

      container.addEventListener('pointerup', (e) => {
        if (!dragging) return;
        dragging = false;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this._stopAutoplay();
          const next = dx < 0 ? (this._current + 1) % this._slides.length : (this._current - 1 + this._slides.length) % this._slides.length;
          this._goTo(next);
          this._startAutoplay();
        }
      });

      container.addEventListener('pointercancel', () => (dragging = false));
    }

    _buildPagination() {
      const pagination = this.querySelector('.menu-drawer__banner-pagination');
      if (!pagination) return;

      this._dots = [];
      this._slides.forEach((slide, i) => {
        const li = document.createElement('li');
        li.className = 'slider__pagination-item' + (i === 0 ? ' slider__pagination-item--active' : '');
        const dot = document.createElement('span');
        dot.className = 'slider__pagination-dot';
        li.appendChild(dot);
        li.addEventListener('click', () => { this._stopAutoplay(); this._goTo(i); this._startAutoplay(); });
        pagination.appendChild(li);
        this._dots.push(li);
      });
    }

    _goTo(index) {
      this._slides[this._current].classList.remove('is-active');
      if (this._dots) this._dots[this._current].classList.remove('slider__pagination-item--active');
      this._current = index;
      this._slides[this._current].classList.add('is-active');
      if (this._dots) this._dots[this._current].classList.add('slider__pagination-item--active');
    }

    _startAutoplay() {
      this._stopAutoplay();
      this._timer = setInterval(() => this._goTo((this._current + 1) % this._slides.length), this._speed);
    }

    _stopAutoplay() {
      clearInterval(this._timer);
    }
  }

  if (!customElements.get('sf-banner-slider')) {
    customElements.define('sf-banner-slider', SfBannerSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_menu-drawer-navigation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-nav-block]').forEach(function (nav) {
    nav.querySelectorAll('[data-banner-target]').forEach(function (banner) {
      var target = banner.dataset.bannerTarget;
      if (target) {
        var panel = nav.querySelector('[data-panel-handle="' + target + '"]');
        if (panel) panel.appendChild(banner);
      } else {
        nav.querySelectorAll('[data-panel-handle]').forEach(function (panel) {
          panel.appendChild(banner.cloneNode(true));
        });
        banner.remove();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_menu-drawer"] && !Shopify.designMode) return;
  try {
    class SfMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.triggers = document.querySelectorAll('[data-menu-drawer-toggle]');
      this.panel = this.querySelector('.drawer__inner');
      this.panelsLayer = this.querySelector('[data-menu-drawer-panels]');
      this.backBtn = this.querySelector('[data-menu-drawer-back]');
      this.searchTrigger = this.querySelector('[data-menu-drawer-search]');
      this.isOpen = false;
      this.stack = [];
      this.onKeydown = this.onKeydown.bind(this);

      this.querySelectorAll('.menu-drawer__panel[data-panel]').forEach((p) => this.panelsLayer.appendChild(p));

      const bar = this.querySelector('.menu-drawer__bar');
      if (bar) this.style.setProperty('--menu-drawer-bar-height', bar.offsetHeight + 'px');

      this.triggers.forEach((t) => t.addEventListener('click', () => (this.isOpen ? this.close() : this.open())));
      this.addEventListener('click', (e) => {
        if (e.target === this) this.close();
      });
      this.querySelectorAll('[data-menu-drawer-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.backBtn.addEventListener('click', () => this.back());
      if (this.searchTrigger) {
        this.searchTrigger.addEventListener('click', () => {
          this.close();
          const searchToggle = document.querySelector('.header__search .modal__toggle');
          if (searchToggle) requestAnimationFrame(() => searchToggle.click());
        });
      }
      this.querySelectorAll('[data-menu-drawer-drill]').forEach((b) =>
        b.addEventListener('click', (e) => this.drill(e.currentTarget))
      );

      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', () => this.open());
        this.addEventListener('shopify:block:deselect', () => this.close());
      }
    }

    setTriggerState(open) {
      this.triggers.forEach((t) => {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.classList.toggle('is-open', open);
      });
    }

    open() {
      if (this.isOpen) return;
      document.querySelector('cart-drawer')?.close();
      document.querySelectorAll('sf-menu-drawer').forEach((d) => {
        if (d !== this && d.isOpen) d.close();
      });
      this.isOpen = true;
      this.prevFocus = document.activeElement;
      setTimeout(() => {
        this.classList.add('active');
      });
      this.setTriggerState(true);
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', this.onKeydown);
      const f = this.panel.querySelector('[data-menu-drawer-close]');
      requestAnimationFrame(() => f && f.focus());
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.setTriggerState(false);
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', this.onKeydown);
      if (this.prevFocus && this.prevFocus.focus) this.prevFocus.focus();

      const rawDuration = getComputedStyle(document.documentElement).getPropertyValue('--duration-default').trim();
      let duration = parseFloat(rawDuration) || 200;
      // CSS value may be seconds ("0.2s") or ms ("200ms"); only scale seconds → ms
      if (/(^|[^m])s$/.test(rawDuration)) duration *= 1000;
      // slide the whole drawer (inner + panels) out together, in one go
      this.classList.remove('active');

      // reset panel/stack state only after it's off-screen → no fold-back flicker
      const snapshots = this.stack;
      this.stack = [];
      setTimeout(() => {
        snapshots.forEach((entry) => {
          entry.panel.classList.remove('is-active');
          entry.panel.hidden = true;
          entry.trigger.setAttribute('aria-expanded', 'false');
        });
        this.updateActive();
        this.updateCrumb();
      }, duration + 30);
    }

    updateActive() {
      this.style.setProperty('--menu-drawer-active', this.stack.length);
      this.classList.toggle('has-panel', this.stack.length > 0);
    }

    closePanel(entry) {
      entry.panel.classList.remove('is-active');
      entry.trigger.setAttribute('aria-expanded', 'false');
      const p = entry.panel;
      const hide = () => {
        if (!p.classList.contains('is-active')) p.hidden = true;
        p.removeEventListener('transitionend', hide);
      };
      p.addEventListener('transitionend', hide);
      window.setTimeout(hide, 420);
    }

    drill(trigger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      const depth = parseInt(panel.dataset.depth, 10) || 1;
      if (this.stack.length && this.stack[this.stack.length - 1].panel === panel) {
        this.back();
        return;
      }

      while (this.stack.length && (parseInt(this.stack[this.stack.length - 1].panel.dataset.depth, 10) || 1) >= depth) {
        const entry = this.stack.pop();
        entry.panel.classList.remove('is-active');
        entry.panel.hidden = true;
        entry.trigger.setAttribute('aria-expanded', 'false');
      }

      panel.hidden = false;
      void panel.offsetWidth;
      panel.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      this.stack.push({ panel, trigger, title: trigger.dataset.title || '' });
      this.updateActive();
      this.updateCrumb();
      const f = panel.querySelector('.menu-drawer__cta, a, button, summary');
      requestAnimationFrame(() => f && f.focus());
    }

    back() {
      const top = this.stack.pop();
      if (!top) return;
      this.closePanel(top);
      this.updateActive();
      this.updateCrumb();
      requestAnimationFrame(() => top.trigger.focus());
    }

    updateCrumb() {
      const inPanel = this.stack.length > 0;
      this.backBtn.hidden = !inPanel;
      if (this.searchTrigger) this.searchTrigger.hidden = inPanel;
    }

    resetStack() {
      this.stack.forEach((s) => {
        s.panel.classList.remove('is-active');
        s.panel.hidden = true;
        s.trigger.setAttribute('aria-expanded', 'false');
      });
      this.stack = [];
      this.updateActive();
      this.updateCrumb();
    }

    onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        if (this.stack.length) this.back();
        else this.close();
        return;
      }
      if (e.key === 'Tab') this.trapFocus(e);
    }

    trapFocus(e) {
      const nodes = this.panel.querySelectorAll(
        'a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'
      );
      const vis = Array.prototype.filter.call(nodes, (el) => el.offsetParent !== null);
      if (!vis.length) return;
      const first = vis[0],
        last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }

  if (!customElements.get('sf-menu-drawer')) customElements.define('sf-menu-drawer', SfMenuDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["add-to-cart-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('add-to-cart-products')) {
    customElements.define(
      'add-to-cart-products',
      class AddToCartProducts extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.button.addEventListener('click', this.onClick.bind(this));
        }

        onClick() {
          const ids = this.dataset.variantIds.split(',').filter(Boolean);
          if (!ids.length || this.button.getAttribute('aria-disabled') === 'true') return;

          const carts = [document.querySelector('cart-notification'), document.querySelector('cart-drawer')].filter(
            Boolean
          );
          const body = { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) };
          if (carts.length) {
            body.sections = carts.flatMap((cart) => cart.getSectionsToRender()).map((section) => section.id);
            body.sections_url = window.location.pathname;
          }

          carts.forEach((cart) => cart.setActiveElement(document.activeElement));
          this.button.setAttribute('aria-disabled', 'true');
          this.button.classList.add('loading');
          this.querySelector('.loading__spinner')?.classList.remove('hidden');

          fetch(`${routes.cart_add_url}`, { ...SF.fetchConfig('javascript'), body: JSON.stringify(body) })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'add-to-cart-products',
                  errors: response.errors || response.description,
                  message: response.message,
                });
                return;
              }
              if (!carts.length) {
                window.location = window.routes.cart_url;
                return;
              }
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'add-to-cart-products', cartData: response });
              // cart-notification renders a single line item from `key`; multi-item adds return `items` instead.
              carts.forEach((cart) => cart.renderContents({ ...response, key: response.items[0].key }));
              this.renderNotificationItems(response);
            })
            .catch((e) => console.error(e))
            .finally(() => {
              this.button.classList.remove('loading');
              this.button.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner')?.classList.add('hidden');
              carts.forEach((cart) => cart.classList.remove('is-empty'));
              window.dispatchEvent(new CustomEvent('SF_added_to_cart'));
            });
        }

        renderNotificationItems(response) {
          const container = document.getElementById('cart-notification-product');
          const html = response.sections?.['cart-notification-product'];
          if (!container || !html || response.items.length < 2) return;

          const doc = new DOMParser().parseFromString(html, 'text/html');
          container.innerHTML = response.items
            .map((item) => doc.querySelector(`[id="cart-notification-product-${item.key}"]`)?.outerHTML ?? '')
            .join('');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
